/*
 * Layout for the admin page
 */

define(["marionette", "modules/admin/template/adminTemplate.html"], function (
  Marionette,
  AdminTemplate,
) {
  var AdminView = {};

  AdminView.adminLayout = Marionette.Layout.extend({
    template: AdminTemplate,
    regions: {
      adminMainArea: "#adminMainArea",
    },
  });

  return AdminView;
});
